/**
 * Use this instead of MUI chip.
 */

import {
  hexToRGB,
  TEAL_300,
  TEAL_600,
} from '@wandb/weave/common/css/globals.styles';
import {IconName} from '@wandb/weave/components/Icon';
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React from 'react';

import * as S from './Chip.styles';

type ChipProps = {
  icon?: string | React.ReactNode;
  label: React.ReactNode;
  tooltip?: string;
  color?: string;
  backgroundColor?: string;
};

const DEFAULT_BACKGROUND_COLOR = hexToRGB(TEAL_300, 0.48);
const DEFAULT_COLOR = TEAL_600;

export const Chip = ({
  icon,
  label,
  tooltip,
  color,
  backgroundColor,
}: ChipProps) => {
  if (typeof icon === 'string') {
    icon = <S.Icon name={icon as IconName} />;
  }
  const style = {
    backgroundColor: backgroundColor ?? DEFAULT_BACKGROUND_COLOR,
    color: color ?? DEFAULT_COLOR,
  };

  const chip = (
    <S.Chip style={style}>
      {icon}
      {label}
    </S.Chip>
  );

  if (tooltip) {
    return <Tooltip content={tooltip} trigger={chip} />;
  }
  return chip;
};
